import IAppointment from '@monorepo-zazuu/shared/interfaces/IAppointment';
import IProfessional from '@monorepo-zazuu/shared/interfaces/IProfessional';

// Áreas da operação usadas para separar a alocação no Controle de Agenda.
// Único lugar com os ids de categoria e os perfis de cada área no admin.
export type ServiceArea = 'todos' | 'vet' | 'banho_tosa';

export const SERVICE_AREA_OPTIONS: { value: ServiceArea; label: string }[] = [
  { value: 'todos', label: 'Todos' },
  { value: 'vet', label: 'Vet' },
  { value: 'banho_tosa', label: 'Banho e Tosa' },
];

// Mesmos ids de CategoriesIdEnum no repo api (src/shared/utils/shared/enums).
// Vacinas entra no Vet (confirmado pela operação).
export const SERVICE_AREA_CATEGORY_IDS: Record<Exclude<ServiceArea, 'todos'>, string[]> = {
  vet: [
    '5d7b1d13-0cf0-482e-83b1-3deecbccd4e1', // Veterinário
    '8cc13037-ab8b-4716-9b34-8d914a2058b1', // Vacinas
  ],
  banho_tosa: [
    '5daabb01-bdec-40b3-b2e1-4698a42c4e3e', // Banho, Tosa e Bem-estar
  ],
};

// Nomes de perfil já normalizados (sem acento, minúsculos). São os perfis de
// categoria 'profissao' da api (veterinário, banhista, tosador), vindos de user.roles.
export const SERVICE_AREA_ROLE_NAMES: Record<Exclude<ServiceArea, 'todos'>, string[]> = {
  vet: ['veterinario'],
  banho_tosa: ['banhista', 'tosador'],
};

export const normalizeRoleName = (name?: string | null): string =>
  (name || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .trim()
    .toLowerCase();

export const appointmentMatchesArea = (
  appointment: IAppointment,
  area: ServiceArea,
): boolean => {
  if (area === 'todos') {
    return true;
  }
  const category_id = appointment?.service?.category_id;
  return !!category_id && SERVICE_AREA_CATEGORY_IDS[area].includes(category_id);
};

// Quem tem perfis das duas áreas aparece nas duas.
export const professionalMatchesArea = (
  professional: IProfessional | undefined,
  area: ServiceArea,
): boolean => {
  if (area === 'todos') {
    return true;
  }
  const roles = professional?.user?.roles || [];
  return roles.some(role => SERVICE_AREA_ROLE_NAMES[area].includes(normalizeRoleName(role.name)));
};
